import useEventListFunctions from 'components/Dashboard/LiveFromParliament/useEventListFunctions';
import useGetRealTimeEvents from 'components/Dashboard/ParliamentLive/useGetRealtimeEvents';
import { createEmbedContentPathname } from 'components/Dashboard/ContentControl/contentApiPaths';
import useFetchSpecificContent from 'components/Dashboard/ContentControl/useFetchSpecificContent';
import time from 'utils/time';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(timezone);

const useEmbedSpecificContentApiCall = (props) => {
  const { includeBrandingProperty, contentState, initialDateState, results, topic } = props;
  const { setInitialDate } = initialDateState ?? {};
  const { content, setContent } = contentState ?? {};

  const { fetchSpecificContent } = useFetchSpecificContent();
  const { callEvents } = useEventListFunctions();
  const { getRealTimeEvent } = useGetRealTimeEvents();

  const callSpecificEvent = async ({ eventId, source }) => {
    try {
      let initialDateEvent;
      let eventBodies;
      const eventItem = await getRealTimeEvent({ source, eventId });
      if (!!eventItem) {
        const dateUK = dayjs().utc();
        const normalizeEventDate = time(eventItem?.actualStartDateTime).utc();
        initialDateEvent = dateUK.isSame(normalizeEventDate, 'day') ? null : normalizeEventDate;
        const eventQuery = await callEvents({ source, eventId, setInitialDate, specificDate: initialDateEvent });
        if (!!eventQuery) {
          eventBodies = eventQuery?.hits?.map((item) => ({ ...item, text: item.body }));
          const currentNew = { eventBodies, eventItem };
          return currentNew;
        }
      }
      return null;
    } catch (error) {}
  };

  const specificContentApiCall = async ({ item, source }) => {
    try {
      if (item) {
        setContent(!!content ? { ...content, isLoading: true } : { isLoading: true });
        let newData;
        if (item?.type === 'RealtimeUtterance') {
          const currentNew = await callSpecificEvent({ eventId: item?.eventId, source });
          if (!!currentNew) {
            newData = { ...currentNew };
          }
        } else {
          const pathname = createEmbedContentPathname({ item, includeBrandingProperty });
          let handpickedTopic = item.type === 'KeyUpdate' && results?.handPickedTopic;
          const preparedContent = await fetchSpecificContent({
            pathname,
            source,
            type: item.type,
            contentType: item.contentType,
            topicId: item?.keywordListId ?? topic?.id,
            includeBrandingProperty,
            highlight: !handpickedTopic,
          });
          if (preparedContent) {
            newData = { ...preparedContent.newData };
          }
        }
        if (!!newData) {
          setContent({
            item: content?.item,
            isLoading: false,
            currentNew: newData,
            contributionId: item.contentType === 'ParliamentaryContribution' ? item.contributionId : null,
          });
        }
      }
    } catch (error) {}
  };

  return { specificContentApiCall };
};

export default useEmbedSpecificContentApiCall;
